import React from 'react';

import Navbar from '../components/Navbar/Navbar';
import About from '../components/About/About';
import Footer from '../components/Footer/Footer';

export default function AboutPage() {
  return (
    <div>
      <Navbar />
      AboutPage
      <About />
      <Footer />
    </div>
  );
}
